import React from "react";
import { Link } from "react-router-dom";

type Article = {
  id: string;
  title: string;
  summary: string;
  tags: string[];
  date?: string;
  readTime?: string;
};

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="relative overflow-hidden border border-border-subtle/60 rounded-card p-5 bg-surface/70 text-text-muted interactive-card transition">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent to-transparent opacity-70" />

      <div className="space-y-2">
        <Link
          to={`/articles/${article.id}`}
          className="font-mono text-lg text-primary hover:text-accent transition inline-flex items-center gap-2"
        >
          {article.title}
        </Link>
        <p className="text-sm leading-relaxed text-text-muted/90">{article.summary}</p>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        {article.tags.map((t) => (
          <span key={t} className="text-[11px] font-mono uppercase tracking-wide px-3 py-1 border border-border-subtle/70 rounded-pill">
            {t}
          </span>
        ))}
      </div>

      <div className="mt-4 text-xs font-mono text-text-subtle flex items-center gap-3">
        {article.date && <span>{article.date}</span>}
        {article.readTime && (
          <>
            <span className="h-1 w-1 rounded-full bg-text-subtle/70" />
            <span>{article.readTime}</span>
          </>
        )}
      </div>
    </article>
  );
}

